import React from "react";
import classes from "./IconList.module.css";

import githubIcon from "../../assets/github.svg";
import linkedinIcon from "../../assets/linkedin.svg";
import resumeIcon from "../../assets/resume.svg";
// import emailIcon from "../../assets/email.svg";
import runIcon from "../../assets/run.svg";

import cv from "../../assets/resume.pdf";

const IconList = (props) => {
  return (
    <div className={classes.Container}>
      <a
        href="https://www.linkedin.com/in/liyx/"
        className={classes.IconContainer}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={linkedinIcon} title="A lifelong learner" alt="LinkedIn" className={classes.Icon} />
      </a>
      <a
        href="https://github.com/limme27"
        className={classes.IconContainer}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={githubIcon} title="A tech guy" alt="GitHub" className={classes.Icon} />
      </a>
      <a
        href="https://strava.com/athletes/liyx"
        className={classes.IconContainer}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={runIcon} title="A marathon runner" alt="Strava" className={classes.Icon} />
      </a>
      <a
        href={cv}
        // download
        className={classes.IconContainer}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={resumeIcon} title="Resume" alt="Resume" className={classes.Icon} />
      </a>
      {/* <a
        href="mailto:archieliyx@gmail.com"
        className={classes.IconContainer}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={emailIcon} alt="" className={classes.Icon} />
      </a> */}
    </div>
  );
};

export default IconList;
